import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const languages = [`pl`, `cs`];

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "pl",
    //debug: true,
    whitelist: languages,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      pl: {
        translation: {
          propozycjaWygasla: "Propozycja już wygasła.",
          skontaktujSieZKonsultantem: "Skontaktuj się ze swoim konsultantem",
          byDowiedziecSieWiecej: "by dowiedzieć się więcej",
          cenaZKartaStalegoKlienta: "Cena z kartą stałego klienta",
          dni: "dni",
          noce: "noce",
          godz: "godz.",
          min: "min",
          dniWypoczynek: "dni wypoczynek",
          noceWypoczynek: "noce wypoczynek",
          wypoczynek: "wypoczynek",
          cenaUzaleznionaOdHotelu: "Cena uzależniona od hotelu",
          cenaZKSK: "Cena z kartą stałego klienta",
          drukuj: "Drukuj",
          zacznijOpisOdNowejStrony: "Zaczynaj opis od nowej strony",
          dodajFakultety: "Dodaj fakultety",
          dolaczMapy: "Dołącz mapy",
          pelenOpis: "Pełen opis",
          wydrukZeZdjeciami: "Wydruk ze zdjęciami",
          wybierzJakChceszAbyWygladalWydruk:
            "Wybierz jak chcesz aby wyglądał Twój wydruk",
          drukDoPDF: "Drukuj do PDF",
          cenyPodanychPropozycjiMogaUlecZmianie:
            "Ceny podanych propozycji mogą ulec zmianie",
          informujemyDaneOsobowe:
            "Informujemy, że podane przez Panią/Pana dane osobowe będą przetwarzane przez Rainbow Tours S.A. z siedzibą: ul. Piotrkowska 270, 90-361 Łódź, jako administratora danych, w celu przedstawienia oferty oraz w celach archiwizacyjnych. Podanie danych jest dobrowolne, jednak niezbędne do realizacji ww. celów. Przysługuje Pani/Panu prawo dostępu do treści swoich danych osobowych oraz ich poprawiania. Państwa dane osobowe będą udostępnione naszym pracownikom w celu przedstawienia oferty.",
          wyrazamZgode:
            "Wyrażam zgodę na otrzymywanie od Rainbow Tours S.A. informacji handlowej za pomocą środków komunikacji elektronicznej na konto poczty elektronicznej zgodnie z ustawą z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną (j.t. Dz.U.2016.1030). Informujemy, że przekazane dane osobowe będą przetwarzane przez Rainbow Tours S.A. z siedzibą: ul. Piotrkowska 270, 90-361 Łódź w celach marketingowych oraz będą archiwizowane w celu zachowania dowodów przed ewentualnymi roszczeniami lub zarzutami. Rainbow Tours S.A. informuje, że zgodnie z art. 24 ust. 1 pkt 3 i 4 ustawy z dnia 29 sierpnia 1997 r. o ochronie danych osobowych, podanie danych jest dobrowolne, a ponadto Użytkownikowi przysługuje prawo dostępu do treści swoich danych oraz ich poprawiania.",
          naPodanyAdresEmail: "Na podany adres e-mail zostanie wysłana oferta.",
          polaOznaczona: "Pola oznaczona * są wymagane",
          wyrazamZgodeNaPrzetwarzanie:
            "*Wyrażam zgodę na przetwarzanie moich danych osobowych w celu nawiazania kontaktu i przedstawienia oferty.",
          chceOtrzymywacOferte:
            "Chcę otrzymywać najlepsze oferty wycieczek na swój adres e-mail.",
          opini: "opini",
          pokazSzczegolowyOpis: "Pokaż szczegółowy opis propozycji",
          dokonajRezerwacjiOnline:
            "Dokonaj rezerwacji online wybierając interesujący Ciebie hotel",
          kalkulujZamow: "Kalkuluj cenę / zamów",
          pokojWyzywienie: "Pokój i wyżywienie",
          pokoj: "Pokój",
          wyzywienie: "Wyżywienie",
          osoby: "Osoby",
          dorosli: "Dorośli",
          dorosly: "Dorosły",
          dzieci: "Dzieci",
          dzieciZMalej: "dzieci",
          trasaWycieczki: "Trasa Wycieczki",
          powrot: "Powrót",
          wybierzHotelPrzedluzenie: "Wybierz hotel na przedłużenie",
          osobyDorosle: "osoby dorosłe",
          lat: "lat",
          szczegolyHotelu: "Szczegóły hotelu",
          pokazNaMapie: "Pokaż na mapie",
          atrybuty: "Atrybuty",
          nicStraconegoSkontaktujSie:
            "Nic straconego! Skontaktuj się z nami lub przejdź na stronę internetową Rainbow i sprawdź jakie inne propozycje przygotowaliśmy z myślą o Tobie.",
          zadzwon: "Zadzwoń do mnie",
          napisz: "Napisz",
          przejdzDoWWW: "Przejdź do strony rainbow",
          copyright:
            "Wszelkie prawa zastrzeżone © 1991 - {{year}} Biuro podróży Rainbow Tours S.A. & eEngine Software House Sp. z o.o.",
          nieStanowiOferty:
            "Niniejsza informacja nie stanowi oferty handlowej w rozumieniu art. 66 §1 Kodeksu Cywilnego",
          wyslijOferte: "Wyślij e-mail z ofertą",
          linkWygasaZa: "Link wygasa za",
          wyslijEmail: "Wyślij e-mail",
          znajdzPlacowke: "Znajdź najbliższą placówkę Rainbow",
          drukujPropozycje: "Drukuj wszystkie propozycje",
          wybranePropozycje: "Wybrane dla Ciebie propozycje",
          sprawdzCeneKSK: "Sprawdź cenę z Kartą Stałego Klienta",
          posiadamKSK: "Posiadam Kartę Stałego Klienta",
          dzienDobry: "Dzień dobry",
          planWycieczki: "Plan wycieczki",
          opisyPropozycji: "Opisy propozycji",
          wprowadzImie: "Wprowadź imię Klienta",
          uwagiDoPropozycji: "Uwagi dotyczące propozycji",
          ukryjSzczegoly: "Ukryj szczegóły",
          pokazSzczegoly: "Pokaż szczegóły",
          wyslijOferteModal: "Wyślij ofertę",
          adresEmail: "Adres e-mail",
          adresEmailNiePusty: "Adres e-mail nie może być pusty",
          poleObowiazkowe: "Pole obowiązkowe",
          wylot: "Wylot"
        },
      },
      cs: {
        translation: {
          propozycjaWygasla: "Platnost nabídky již skončila.",
          skontaktujSieZKonsultantem: "Kontaktujte svého konzultanta.",
          byDowiedziecSieWiecej: "zjistit více informací",
          cenaZKartaStalegoKlienta: "Cena s kartou stálého klienta",
          dni: "dny",
          noce: "nocí",
          godz: "hod.",
          min: "min",
          dniWypoczynek: "dnů odpočinku",
          noceWypoczynek: "nocí odpočinku",
          wypoczynek: "odpočinek",
          cenaUzaleznionaOdHotelu: "Cena závisí na hotelu",
          cenaZKSK: "Cena s kartou stálého klienta",
          drukuj: "Vytisknout",
          zacznijOpisOdNowejStrony: "Začněte popis na nové stránce",
          dodajFakultety: "Přidat fakultativní výlety",
          dolaczMapy: "Včetně map",
          pelenOpis: "Plný popis",
          wydrukZeZdjeciami: "Tisk s fotografiemi",
          wybierzJakChceszAbyWygladalWydruk: "Vyberte si, jak má tisk vypadat",
          drukDoPDF: "Tisk do PDF",
          cenyPodanychPropozycjiMogaUlecZmianie:
            "Ceny uvedených návrhů se mohou změnit",
          informujemyDaneOsobowe:
            "Rádi bychom vás informovali, že vámi poskytnuté osobní údaje budou zpracovává společnost Rainbow Tours S.A. se sídlem na ul. Piotrkowska 270, 90-361 Lodž, jako správce údajů, za účelem účely prezentace nabídky a pro účely archivace. Poskytnutí údajů je dobrovolné, je však nezbytné pro realizaci výše uvedených účelů. Máte právo na přístup ke svým osobním údajům a na jejich opravu. Vaše osobní údaje budou zpřístupněny našim zaměstnancům za účelem představení nabídky.",
          wyrazamZgode:
            "Souhlasím s tím, aby mi společnost Rainbow Tours S.A. zasílala obchodní sdělení prostřednictvím elektronické komunikace na emailovou adresu v souladu se zákonem ze dne 18. července 2002 o poskytování služeb elektronickými prostředky (j.t. Dz.U.2016.1030). Informujeme, že poskytnuté osobní údaje budou zpracovávány společností Rainbow Tours S.A. se sídlem: ul. Piotrkowska 270, 90-361 Łódź pro marketingové účely a budou archivovány za účelem uchování důkazů proti případným nárokům nebo obviněním. Společnost Rainbow Tours S.A. informuje, že že v souladu s článkem 24.1.3 a 24.1.4 zákona ze dne 29. srpna 1997 o ochraně osobních údajů je poskytnutí údajů dobrovolné a uživatel má navíc právo na přístup k obsahu svých údajů a na jejich opravu.",
          naPodanyAdresEmail:
            "Nabídka bude zaslána na zadanou e-mailovou adresu.",
          polaOznaczona: "Pole označená * jsou povinná",
          wyrazamZgodeNaPrzetwarzanie:
            "*Souhlasím se zpracováním svých osobních údajů za účelem navázání kontaktu a představením nabídky.",
          chceOtrzymywacOferte:
            "Chci dostávat nejlepší nabídky zájezdů na svou e-mailovou adresu.",
          opini: "recenze",
          pokazSzczegolowyOpis: "Zobrazit podrobný popis nabídky",
          dokonajRezerwacjiOnline:
            "Proveďte rezervaci online výběrem hotelu, o který máte zájem.",
          kalkulujZamow: "Kalkulace ceny / objednávky",
          pokojWyzywienie: "Ubytování a strava",
          pokoj: "Pokoj",
          wyzywienie: "Strava",
          osoby: "Osoby",
          dorosly: "Dospělý",
          dorosli: "Dospělí",
          dzieci: "Děti",
          dzieciZMalej: "děti",
          trasaWycieczki: "Trasa zájezdu",
          powrot: "Návrat",
          wybierzHotelPrzedluzenie: "Vyberte hotel na prodloužení",
          osobyDorosle: "dospělé osoby",
          lat: "let",
          szczegolyHotelu: "Detaily hotelu",
          pokazNaMapie: "Zobrazit na mapě",
          atrybuty: "Atributy",
          nicStraconegoSkontaktujSie:
            "Nic není ztraceno! Kontaktujte nás nebo přejděte na stránky Rainbow a podívejte se na další nabídky, které jsme pro Vás připravili.",
          zadzwon: "Zavolejte mi",
          napisz: "Napište",
          przejdzDoWWW: "Přejít na stránky Rainbow",
          copyright:
            "Všechna práva vyhrazena © 1991 - {{year}} Cestovní kancelář Rainbow Tours S.A.",
          nieStanowiOferty:
            "Tyto informace nepředstavují obchodní nabídku ve smyslu art. 66 §1 Kodeksu Cywilnego",
          wyslijOferte: "Pošlete email s nabídkou",
          linkWygasaZa: "Platnost odkazu vyprší za",
          wyslijEmail: "Pošli e-mail",
          znajdzPlacowke: "Najděte nejbližší pobočku Rainbow",
          drukujPropozycje: "Vytisknout všechny návrhy",
          wybranePropozycje: "Návrhy vybrané pro Vás",
          sprawdzCeneKSK: "Cena s kartou stálého klienta",
          posiadamKSK: "Vlastním kartu stálého klienta",
          dzienDobry: "Dobrý den",
          planWycieczki: "Itinerář zájezdu",
          opisyPropozycji: "Popisy návrhů",
          wprowadzImie: "Zadej jméno klienta",
          uwagiDoPropozycji: "Připomínky k návrhu",
          ukryjSzczegoly: "Skrýt detaily",
          pokazSzczegoly: "Ukaž mi podrobnosti",
          wyslijOferteModal: "Odeslat nabídku",
          adresEmail: "Emailová adresa",
          adresEmailNiePusty: "E-mailová adresa nesmí být prázdná",
          poleObowiazkowe: "Povinné pole",
          wylot: "Odchod"
        },
      },
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18next.js